export enum ConversationCreatorType {
  USER = "user",
  META_USER = "meta_user",
  META_PAGE = "meta_page",
  WHATSAPP_ACCOUNT = "whatsapp_account",
  CUSTOMER = "customer",
  AUTOMATION_AGENT = "automation_agent",
}
